<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container" [ngClass]="{'container-fluid': router?.url === '/home-10' || router?.url === '/home-11'}">
        <a class="navbar-brand" routerLink="/">
            <img src="assets/img/AM_Media_title_logo.png" style="width: 230px;" alt="image">
        </a>

        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav">
                <li class="nav-item"><a routerLink="/" class="nav-link">Home</a>
                </li>

                <li class="nav-item"><a routerLink="/about" class="nav-link">About Us</a>
                </li>

                <li class="nav-item"><a routerLink="/" class="nav-link">Course</a>
                </li>

                <li class="nav-item"><a routerLink="/" class="nav-link">Services <i class="icofont-simple-down"></i></a>
                    <ul class="dropdown-menu">
                        <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"><a
                                routerLink="/media-service" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">Media</a></li>

                        <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"><a
                                routerLink="/sports-service" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">Sports</a></li>
                    </ul>
                </li>

                <li class="nav-item"><a routerLink="/" class="nav-link">Gallery</a>
                </li>

                <li class="nav-item"><a routerLink="/" class="nav-link">Blog</a>
                </li>

                <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"><a
                        routerLink="/contact" class="nav-link" routerLinkActive="active"
                        [routerLinkActiveOptions]="{exact: true}">Contact</a></li>
            </ul>

            <div class="others-option">
                <div class="modal-taggle-button">
                    <a href="#" data-bs-toggle="modal" data-bs-target="#sidebarModal"><span></span></a>
                </div>
            </div>
        </div>
    </div>
</nav>

<div class="modal right fade sidebarModal" id="sidebarModal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"><span
                        aria-hidden="true">&times;</span></button>
            </div>
            <div class="modal-body">
                <div class="logo"><a routerLink="/"><img src="assets/img/AM_Media_title_logo.png" style="width: 250px;"
                            alt="logo"></a></div>
                <p>Welcome to AM Media and Sports Pvt Ltd—where media and sports come together to inspire, educate, and
                    empower communities through innovative storytelling and dynamic sporting experiences. </p>
                <ul class="modal-contact-info">
                    <li><i class="icofont-envelope"></i> <strong>info&#64;ammediasports.com</strong> 24/7 online support
                    </li>
                </ul>
                <ul class="social-links">
                    <li><a href="https://www.facebook.com/people/A-M-Media-and-Sports/61575779366522/"
                            target="_blank"><i class="icofont-facebook"></i></a></li>
                    <li><a href="https://x.com/ammediasports"><i class="icofont-x"></i></a></li>
                    <li><a href="https://www.instagram.com/ammediasports/"><i class="icofont-instagram"></i></a></li>
                    <li><a href="https://www.linkedin.com/company/am-media-and-sports-pvt-ltd"><i
                                class="icofont-linkedin"></i></a></li>
                </ul>
            </div>
        </div>
    </div>
</div>